module.exports = __webpack_public_path__ + "img/teacher_bg.66afcf86.jpg";